import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Eye, EyeOff, ArrowRight, User } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function FreelancerLogin() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [form, setForm] = useState({ email: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const result = await login(form.email, form.password);
      if (!result.success) {
        setError(result.error || 'Giriş başarısız. E-posta ve şifreyi kontrol edin.');
        return;
      }
      const isFreelancer = result.user?.org_memberships?.some(m => m.role?.startsWith('FREELANCER'));
      if (!isFreelancer) {
        setError('Bu hesap bir freelancer hesabı değil. Lütfen doğru portaldan giriş yapın.');
        return;
      }
      navigate('/app/freelancer/dashboard');
    } catch (err) {
      setError(err?.response?.data?.detail || 'Giriş başarısız. E-posta ve şifreyi kontrol edin.');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <Link to="/" className="inline-flex items-center gap-2 text-white font-black text-xl mb-6">
            <div className="w-8 h-8 bg-red-600 rounded-lg flex items-center justify-center">
              <span className="text-white font-black text-sm">ES</span>
            </div>
            EXPO STAND
          </Link>
          <div className="w-12 h-12 rounded-2xl bg-red-600 flex items-center justify-center mx-auto mb-4">
            <User className="w-6 h-6 text-white" />
          </div>
          <h2 className="text-2xl font-black text-white">Freelancer Girişi</h2>
          <p className="text-gray-400 text-sm mt-1">Freelancer hesabınla giriş yap</p>
        </div>

        {error && (
          <div className="mb-4 p-3 bg-red-900/30 border border-red-800 rounded-xl text-red-300 text-sm">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <input type="email" value={form.email} onChange={e => setForm(p => ({ ...p, email: e.target.value }))}
            placeholder="E-posta adresi" required
            className="w-full bg-gray-800 border border-gray-700 text-white text-sm rounded-xl px-4 py-3 focus:outline-none focus:border-red-500 transition-colors" />
          <div className="relative">
            <input type={showPassword ? 'text' : 'password'} value={form.password}
              onChange={e => setForm(p => ({ ...p, password: e.target.value }))}
              placeholder="Şifre" required
              className="w-full bg-gray-800 border border-gray-700 text-white text-sm rounded-xl px-4 py-3 pr-10 focus:outline-none focus:border-red-500 transition-colors" />
            <button type="button" onClick={() => setShowPassword(p => !p)} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400">
              {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
            </button>
          </div>
          <button type="submit" disabled={loading}
            className="w-full bg-red-600 hover:bg-red-700 text-white font-bold py-3 rounded-xl flex items-center justify-center gap-2 transition-colors disabled:opacity-50">
            {loading ? <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" /> : <>Giriş Yap <ArrowRight className="w-4 h-4" /></>}
          </button>
        </form>

        <div className="mt-6 text-center space-y-2">
          <p className="text-gray-500 text-xs">
            Hesabın yok mu?{' '}
            <Link to="/freelancer/signup" className="text-red-400 hover:text-red-300">Freelancer kaydol</Link>
          </p>
          <p className="text-gray-600 text-xs">
            <Link to="/" className="hover:text-gray-400">← Ana sayfaya dön</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
